import React, { useState } from "react";
import { postSkill, patchSkill } from "@/api/skills";

// Dummy category options for now
const dummyCategories = [
    { id: 1, categoryName: "Chefs" },
    { id: 2, categoryName: "Housekeeping" },
    { id: 3, categoryName: "Bartending" },
    { id: 4, categoryName: "Waiting Staff" },
];

const priceUnits = ["hour", "day", "week"];

export default function SkillForm({ skill = null, onSave }) {
    const [formData, setFormData] = useState({
        name: skill?.name || "",
        priceStart: skill?.priceStart || "",
        priceEnd: skill?.priceEnd || "",
        pricePerUnit: skill?.pricePerUnit || "day",
        payRate: skill?.payRate || "",
        skillsCategoryId: skill?.skillsCategory?.id || dummyCategories[0].id,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const payload = {
            name: formData.name,
            priceStart: parseFloat(formData.priceStart) || null,
            priceEnd: parseFloat(formData.priceEnd) || null,
            pricePerUnit: formData.pricePerUnit,
            payRate: parseFloat(formData.payRate) || null,
            skillsCategoryId: parseInt(formData.skillsCategoryId),
        };

        const result = skill?.id
            ? await patchSkill(skill.id, payload)
            : await postSkill(payload);

        setLoading(false);

        if (result) {
            onSave?.(result); // callback to parent to close modal + refresh list
        } else {
            setError("Something went wrong. Please try again.");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {error && <p className="text-red-600 text-sm">{error}</p>}

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                <select
                    name="skillsCategoryId"
                    value={formData.skillsCategoryId}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                    {dummyCategories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                            {cat.categoryName}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Skill Name</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Starting Price</label>
                    <input
                        type="number"
                        name="priceStart"
                        value={formData.priceStart}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Top Price</label>
                    <input
                        type="number"
                        name="priceEnd"
                        value={formData.priceEnd}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Price Unit</label>
                <select
                    name="pricePerUnit"
                    value={formData.pricePerUnit}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                    {priceUnits.map((unit) => (
                        <option key={unit} value={unit}>
                            {unit.charAt(0).toUpperCase() + unit.slice(1)}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Pay Rate (Weekly)</label>
                <input
                    type="number"
                    name="payRate"
                    value={formData.payRate}
                    onChange={handleChange}
                    placeholder="Enter weekly pay rate (e.g., 100.00)"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    step="0.01"
                    min="0"
                />
                <p className="text-xs text-gray-500 mt-1">This is the weekly pay rate for candidates with this job title.</p>
            </div>

            <div className="pt-4">
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-[#5D1F42] text-white text-sm px-4 py-2 rounded-lg hover:bg-[#712a55] transition"
                >
                    {loading ? "Saving..." : skill ? "Update Job Title" : "Create Job Title"}
                </button>
            </div>
        </form>
    );
}
